import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";

const OptionDoble = ({
    config,
    key,
    selected,
    multipleRow,
    option,
    onClick,
    onChange = () => { }
}) => {

    const Option = styled.div`
        ${props => `
            flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
            border-radius: 1vh;
            font-size: 2.5vh;
            text-align: center;
            padding: 1.5vh;
            font-weight: bold;
            cursor: pointer;

            ${props.selected ? `
                animation-name: select;
                background: #3C3C3B;
                color: white;
                font-weight: bold;
            ` : `
                background: white;
                animation-name: none;
            `};
        `};
    `;

    const Image = styled.img`
        margin-left: 1vh;
        width: 1vw;
        height: 1.8vh;
    `;

    const [text, setText] = useState()

    useEffect(() => {
        let select = false
        let optionText = "";
        option?.suboptions.forEach(element => {
            if (element.selected === true) {
                select = true
                optionText = element.option;
            }
        })
        if (select === true) {
            setText(" - " + config.getTranslatedText(optionText));
        }
        else{
            setText("");
        }
    })

    return (
        <Option
            key={key}
            selected={selected}
            multipleRow={multipleRow}
            onClick={onClick}
        >
            {config.getTranslatedText(option?.option)}
            {text}
            <Image src={option?.selected ? require(`../../assets/images/btn_flecha_write.png`) : require(`../../assets/images/btn_flecha.png`)}/>
        </Option>
    );
};

export default OptionDoble;